<template>
    <div>
        <loading-dom style="position: fixed; z-index: 999999;"></loading-dom>
    </div>
</template>
<script>
import "@/utils/flexible";
export default {
    name: "",
    data() {
        return {

        }
    },
    components: {
        loadingDom: ()=> import("@/page/app/page_loading.vue"),
    },
}
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
</style>